import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-ivory-light" data-id="element-76" data-mp="9ktc3i8tpsv4">
      <div className="absolute inset-x-0 top-0 h-px bg-gold/40" aria-hidden="true" data-id="element-77" data-mp="9lbkteco9zjx" />
      <div className="mx-auto max-w-3xl px-5 pb-9 pt-6 text-center sm:px-8 sm:pb-14 sm:pt-10" data-id="element-78" data-mp="4n1k6o86i6qx">
        <p className="text-[10.5px] font-semibold uppercase tracking-[0.2em] text-teal sm:text-xs" data-id="element-79" data-mp="128607wumu8qj">
          Professional Speech Therapy Resource System
        </p>

        <h1 className="mx-auto mt-3 max-w-2xl font-display text-[30px] font-semibold leading-[1.08] tracking-tightish text-navy-deep sm:mt-4 sm:text-[46px]" data-id="element-80" data-mp="sb1efy4p8fa9">
          The Complete Clinical Planning System for Speech Therapists
        </h1>

        <p className="mx-auto mt-3.5 max-w-xl text-[14px] leading-snug text-navy-soft sm:mt-5 sm:text-lg" data-id="element-81" data-mp="3d33h34xud5nx">
          Save hours planning sessions, choosing therapy activities, writing treatment goals,
          documenting progress and preparing clinical resources — without building every therapy
          session from scratch.
        </p>

        <img src={PRODUCT_IMAGE} alt="Speech Therapy Clinical Toolkit, the complete professional speech therapy system" className="mx-auto mt-5 w-full max-w-[580px] sm:mt-7" loading="eager" data-id="element-82" data-mp="39acwuma4biry" />

        <p className="mt-1 text-[10.5px] font-semibold uppercase tracking-[0.2em] text-teal sm:text-xs" data-id="element-83" data-mp="30gzteqefgyrm">
          Speech Therapy Clinical Toolkit™
        </p>
        <p className="mx-auto mt-1.5 max-w-md text-[14.5px] font-semibold leading-snug text-navy-deep sm:text-lg" data-id="element-84" data-mp="2qjv4wjx40r7n">
          The complete 6-in-1 professional system — 1 master clinical guide + 5 premium bonus
          resources
        </p>

        <div className="mt-4 flex items-center justify-center gap-2 text-[11.5px] font-semibold uppercase tracking-[0.12em] text-navy sm:text-sm" data-id="element-85" data-mp="2hkgj3xrw14th">
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-86" data-mp="s21h48i0i7ye">Open</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-87" data-mp="nbbev44vul7x" />
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-88" data-mp="n98dxp26z7of">Choose</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-89" data-mp="i9vqp37erylb" />
          <span className="rounded-full bg-ivory px-3 py-1.5 shadow-card sm:px-3.5 sm:py-2" data-id="element-90" data-mp="deyitzlv7va0">Use</span>
        </div>

        <div className="mx-auto mt-5 max-w-md" data-id="element-91" data-mp="1ayjilhmnxm7u">
          <CtaButton microcopy="Instant digital access • One-time payment" data-id="element-92" data-mp="162udyzvsdf4o">
            Get instant access
          </CtaButton>
        </div>
      </div>
    </header>;
}